// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"1207d6ee","415":"226e6bcf","435":"698ead70","461":"e92ce2c4","493":"8530dc40","518":"ae2bce63","669":"cbce2eee","670":"f18fb36c","816":"a0a5c229","913":"b7f572eb"}[chunkId] + ".chunk.js";
};